import { useAxios } from '@vueuse/integrations/useAxios'
import instance from './index'

/**
 * 基于 VueUse 的 useAxios 封装
 * 自动继承项目全局 axios 拦截器（签名、Token、错误处理等）
 *
 * @param {string} url 请求路径
 * @param {object} config Axios 请求配置
 * @param {object} options VueUse useAxios 配置 (如 immediate)
 */
export function useReq (url, config = {}, options = {}) {
  return useAxios(url, config, instance, {
    immediate: true,
    ...options,
  })
}
